import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "@/data/content";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-[#F5F5F5]" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Häufige Fragen</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0C2749] mb-6" style={{ fontFamily: "Outfit" }}>
            Antworten, bevor Sie fragen.
          </h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Hier finden Sie Antworten auf die wichtigsten Fragen rund um Ihren Rohbau. Etwas Spezifischeres? Sprechen Sie uns einfach an.
          </p>
        </div>
        <div className="lg:col-span-8">
          <div className="border-t border-slate-200">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full text-left py-6 flex items-center justify-between gap-6 group"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="text-base md:text-lg font-medium text-[#0C2749] group-hover:text-[#2873B8] transition-colors" style={{ fontFamily: "Outfit" }}>
                      {f.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 text-[#2873B8] flex-shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                  </button>
                  <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] pb-6" : "grid-rows-[0fr]"}`}>
                    <div className="overflow-hidden">
                      <p className="text-sm md:text-base text-slate-600 leading-relaxed pr-10">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
